module.exports = __webpack_public_path__ + "static/img/13.2c58100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/13.png
// module id = zAaw
// module chunks = 35